<template>
  <div>
    <v-progress-circular
      indeterminate
      :size="35"
      :color="circularColor"
      :width="circularWidth"
      :class="{
        app__circular: onAppCircular
      }"
    >
    </v-progress-circular>
    <div
      :class="{
        'overlay--active': overlayActive,
        'background-color-default': onBackgroundColor
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'loadingOverlayCircular',
  props: {
    onAppCircular: {
      type: Boolean,
      required: false,
      default: true
    },
    onBackgroundColor: {
      type: Boolean,
      required: false,
      default: true
    },
    circularColor: {
      type: String,
      required: false,
      default: 'dark_blue'
    },
    circularWidth: {
      type: String,
      required: false,
      default: '4'
    },
    overlayActive: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>

<style scoped>
.overlay--active {
  opacity: 0.46;
  content: '';
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  -webkit-transition: inherit;
  transition: inherit;
  -webkit-transition-delay: 0.15s;
  transition-delay: 0.15s;
  z-index: 900;
}
.background-color-default {
  background-color: #212121;
}
.app__circular {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 100%;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/_atoms/loadings/LoadingOverlayCircular.vue